import React from "react";
import { clsx } from "clsx";
import { differenceInMinutes } from "date-fns";
import { Placeholder } from "@bloomberg/media-ui-article";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";

import { RelativeTimestamp } from "~components/shared/relative-timestamp";
import { type LiveBlogPost } from "~types/types";

import styles from "./liveblog.module.css";

const MAX_CONTENT_SIZE = 130;
const URGENCY_CUT_OFF_MINS = 30;

export interface LiveBlogPostProps {
    post: LiveBlogPost;
    url?: string;
    className?: string;
    storyIndex: number;
    relatedIndex: number;
}

function constructLink({ url, postId }: { url?: string; postId?: string }) {
    if (postId && url) {
        if (url.includes("?")) {
            return `${url}&cursorId=${postId}`;
        }

        return `${url}?cursorId=${postId}`;
    }

    return url;
}

export function LiveBlogPost({
    storyIndex,
    relatedIndex,
    post,
    url,
    className,
}: LiveBlogPostProps) {
    const now = new Date();
    const relativeDate = new Date(post.updatedAt);
    const dateDiff = differenceInMinutes(now, relativeDate);
    return (
        <div
            className={clsx([
                className,
                styles.post,
                typographyStyles.articleDek,
                dateDiff < URGENCY_CUT_OFF_MINS && styles.urgent,
            ])}
            data-component="liveblog-post"
        >
            <a
                data-link-index={storyIndex}
                data-link-related-index={relatedIndex}
                href={constructLink({ url, postId: post.id })}
                rel="noopener"
            >
                <RelativeTimestamp date={post.updatedAt} />
                <div className={styles.content}>
                    {post.content.slice(0, MAX_CONTENT_SIZE)}
                </div>
            </a>
        </div>
    );
}

export function PostPlaceholder() {
    return (
        <div className={clsx([styles.post, styles.placeholder])}>
            <Placeholder.Image />
        </div>
    );
}
